// extracted by mini-css-extract-plugin
module.exports = {"updatePaymentDetails":"ChangePayment_updatePaymentDetails__2uAJ0","poweredByStripe":"ChangePayment_poweredByStripe__2Ujyw","notice":"ChangePayment_notice__1n1F6"};